import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Image from "next/image";
import Store from "../utils/Store";
import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useStoreState } from "pullstate";
import UserIcon from "./common/UserIcon";
import { filter, get, has, isEmpty, map } from "lodash";
import { faAlignJustify, faAngleLeft, faArrowRightFromBracket, faArrowUpArrowDown, faChevronDown, faChevronLeft, faCircleInfo, faCircleUser, faFileArrowUp, faGear, faInfoCircle, faKey, faLocationDot, faMessagesQuestion, faMoon, faSearch, faSunBright, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { faBadgeCheck, faChevronRight, faCircle, faPencil, faPlus, faQuestionCircle, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { Dialog, Transition } from "@headlessui/react";
import { useAuth } from "@qure/qure-auth";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { useProductFruitsApi } from "react-product-fruits";
import useCheckAdmin from "../hooks/useCheckAdmin";
import useCheckBulkActions from "../hooks/useCheckBulkActions";
import useCheckDashboardContainer from "../hooks/useCheckDashboardContainer";
import useCheckViewerPage from "../hooks/useCheckViewerPage";
import useCheckWorklistContainer from "../hooks/useCheckWorklistContainer";
import { getAppLogo, getCurrentRegion, getIsOnpremise, getIsPatientDeletionEnabled, getIsRemoteSystem, getUrlAuthToken, isIOSWebView, isWebView } from "../utils";
import constants from "../utils/constants";
import getEnv from "../utils/getEnv";
import { trackEvent } from "../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../utils/mixpanelEvents";
import AdminViewBtn from "./AdminViewBtn";
import useMenubarActions from "./Assistant/utils/actions/useMenubarActions";
import AwesomeIcon from "./AwesomeIcon";
import Button from "./common/Button";
import Dropdown from "./common/Dropdown";
import DropdownMenu from "./common/DropdownMenu";
import Modal from "./common/Modal";
import Tooltip from "./common/Tooltip";
import { GatewayContext } from "./GatewayIndicator/GatewayContext";
import GatewayDropdown from "./GatewayIndicator/GatewayDropdown";
import { LicenseContext } from "./LicenseManager/LicenseContext";
import { PatientsContext } from "./Patients/PatientsContext";
import SelectWorkspace from "./SelectWorkspace";
import { useQueryClient } from "react-query";
import useGetViewerRoute from "../hooks/useGetViewerRoute";
import SettingsMenu from "./Settings/SettingsMenu";
import useSettings from "./Settings/useSettings";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import getPatientsV2 from "./Patients/services/getPatientsV2";
import { SORT_BY_MAP } from "../types/sort";
import { buildMultiSelectFilterRequest } from "./SearchFilters/utils";
var Menubar = function Menubar() {
  var _filter$, _activePatientDetail$, _activePatientDetail$2, _ref, _activePatientDetail$3, _userWorkspaces$filte;
  // useChangeTheme();

  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    showSwiftFilter = _useState2[0],
    setShowSwiftFilter = _useState2[1];
  var _useState3 = useState(false),
    isTourEnabled = _useState3[0],
    setEnableTour = _useState3[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        swiftModeEnabled: s.swiftModeEnabled,
        hasMobileSearch: s.hasMobileSearch,
        isSupportWidgetOpen: s.isSupportWidgetOpen
      };
    }),
    swiftModeEnabled = _useStoreState.swiftModeEnabled,
    hasMobileSearch = _useStoreState.hasMobileSearch,
    isSupportWidgetOpen = _useStoreState.isSupportWidgetOpen;
  var _useState4 = useState(false),
    showTermsAndConditionsModal = _useState4[0],
    setShowTermsAndConditionsModal = _useState4[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var params = get(router, ["query", "params"], []);
  var patient_uid = params && params.length ? Number((params === null || params === void 0 ? void 0 : params.length) > 1 ? params === null || params === void 0 ? void 0 : params[1] : params === null || params === void 0 ? void 0 : params[0]) : "";
  var hideMenubar = !!patient_uid && get(router, ["route"], "").includes("/patients/");
  var isWorkList = useCheckWorklistContainer();
  var isDashboard = useCheckDashboardContainer();
  var isAdminView = useCheckAdmin();
  var isBulkActions = useCheckBulkActions();
  var isViewer = useCheckViewerPage();
  var _useContext = useContext(PatientsContext),
    patientsData = _useContext.patientsData,
    setLastId = _useContext.setLastId,
    getFilterParams = _useContext.getFilterParams,
    filters = _useContext.filters,
    count = _useContext.count,
    setFilters = _useContext.setFilters,
    wsData = _useContext.wsData,
    selectedWorkspace = _useContext.selectedWorkspace,
    setSelectedWorkspace = _useContext.setSelectedWorkspace,
    userWorkspaces = _useContext.userWorkspaces,
    savedFilterData = _useContext.savedFilterData,
    sortParams = _useContext.sortParams;
  var _patientsData = get(patientsData, ["data", "content"], []);
  var _patientsUID = map(_patientsData, "patient_uid");
  var isNotificationSettings = get(router, ["pathname"], "").includes("notification-settings");
  var isGatewayIndicator = get(router, ["pathname"], "").includes("gateway-indicator");
  var isPatientRegistration = get(router, ["pathname"], "").includes("patient-registration");
  var isFormSettings = get(router, ["pathname"], "").includes("form-settings");
  var _useContext2 = useContext(GatewayContext),
    offlineGatewayCount = _useContext2.offlineGatewayCount,
    totalGateway = _useContext2.totalGateway;
  var _useSettings = useSettings(),
    openSetting = _useSettings.openSetting;
  var _useContext3 = useContext(LicenseContext),
    alertDetails = _useContext3.alertDetails;
  var query = get(router, ["query"], {});
  var onlyViewport = has(query, ["onlyViewport"]);
  var ALLOWED_REGIONS_FOR_PHONE_AUTH = ["india-stroke.qure.ai"].concat(_toConsumableArray(constants.TESTING_REGIONS));
  var isLC = process.env.NEXT_PUBLIC_IS_LC === "true";
  var isViewerPage = (!isWorkList && !isDashboard && !isAdminView && !isBulkActions || isNotificationSettings || isGatewayIndicator || isPatientRegistration) && !isFormSettings;
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var user = get(userInfo, ["details"], null);
  var _useStoreState2 = useStoreState(Store, function (store) {
      return {
        patientBio: store.patientBio,
        isGetFullAccessOpen: store.isGetFullAccessOpen,
        currentPatient: store.patientDetail,
        isSettingsOpen: store.isSettingsOpen,
        isStartingDownload: store.isStartingDownload,
        isDarkMode: store.isDarkMode
      };
    }),
    patientBio = _useStoreState2.patientBio,
    isGetFullAccessOpen = _useStoreState2.isGetFullAccessOpen,
    isSettingsOpen = _useStoreState2.isSettingsOpen,
    isDarkMode = _useStoreState2.isDarkMode;
  var queryClient = useQueryClient();
  var metabase_enabled = get(userInfo, ["metabase_enabled"], false);
  var phoneNumber = get(userInfo, ["phone_number"], null);
  var diskUsage = get(userInfo, ["disk_usage"], {});
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var activePatientDetail = (_filter$ = filter(_patientsData, ["patient_uid", patient_uid])[0]) !== null && _filter$ !== void 0 ? _filter$ : {};
  var page_size = get(patientsData, ["data", "page_size"]);
  var indexOfCurrentPatient = _patientsUID.indexOf(patient_uid);
  var hasPatientDetails = !isEmpty(activePatientDetail) || !isEmpty(patientBio);
  var urlAuthToken = getUrlAuthToken();
  var DiskAlertbuttonRef = useRef(null);
  var LicenseAlertbuttonRef = useRef(null);
  var viewerRoute = useGetViewerRoute();
  var isNewViewer = router.pathname.includes("viewer-v2");
  var logo = getAppLogo();
  useProductFruitsApi(function (api) {
    if (getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID") && isTourEnabled) {
      api.tours.tryStartTour(getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID"));
      api.tours.listen("tour-finished", onTourFinished);
      api.tours.listen("tour-skipped", onTourFinished);
    }
  }, [isTourEnabled, getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID")]);
  var onTourFinished = function onTourFinished() {
    setEnableTour(false);
  };
  useEffect(function () {
    if (localStorage.getItem(constants.PERSISTED.isSwiftReportModeEnabled)) {
      Store.update(function (s) {
        s.swiftModeEnabled = true;
      });
    } else {
      Store.update(function (s) {
        s.swiftModeEnabled = false;
      });
    }
  }, []);
  useEffect(function () {
    if (indexOfCurrentPatient === _patientsUID.length - 2 && page_size === 10) {
      setLastId(_patientsUID[_patientsUID.length - 1]);
    }
  }, [indexOfCurrentPatient]);
  var handleChangeButton = function handleChangeButton(type) {
    if (indexOfCurrentPatient !== -1) {
      if (type === "next" && indexOfCurrentPatient !== _patientsData.length) {
        router.replace("".concat(viewerRoute).concat(_patientsUID[indexOfCurrentPatient + 1]));
      } else if (indexOfCurrentPatient !== 0) {
        router.replace("".concat(viewerRoute).concat(_patientsUID[indexOfCurrentPatient - 1]));
      }
      trackEvent(MIXPANEL_EVENTS.VIEWER_HEADER_NAVIGATION, {
        type: type
      });
    } else {
      // Get the array of selected filters (could be single or multiple)
      // filters.selectedFilters should be an array of objects with { id, values }
      var selectedFilters = (filters === null || filters === void 0 ? void 0 : filters.selectedFilters) || [];
      var filtersArray = _toConsumableArray(selectedFilters);
      if (savedFilterData) {
        filtersArray.push({
          values: savedFilterData
        });
      }
      // Map sort_by from SORT_BY_MAP to the new structure
      var sortByValue = "study";
      if (sortParams.orderBy === SORT_BY_MAP.updated_at) {
        sortByValue = "recent";
      } else if (sortParams.orderBy === SORT_BY_MAP.created_at) {
        sortByValue = "created";
      } else if (sortParams.orderBy === SORT_BY_MAP.reminder) {
        sortByValue = "reminder";
      }

      // Use new MultiSelectFilterRequest structure
      // Pass specialCustomTagIds from filters state to convert program_type, ai_recommendation, manual_review to custom tags
      var _params = buildMultiSelectFilterRequest(filtersArray, {
        logic: filters.multiSelectLogic || "AND",
        page_size: 1,
        sort_by: sortByValue,
        sort_order: sortParams.order || "desc",
        pagination_id: Number(patient_uid),
        page: type,
        unread_messages: filters.unread_messages || false,
        only_counts: false,
        search: get(filters, ["data", "search"], ""),
        selectedWorkspace: selectedWorkspace,
        specialTagIds: filters.specialCustomTagIds || null,
        customFields: []
      });
      getPatientsV2(_params, {}).then(function (_patientsData) {
        router.replace("".concat(viewerRoute).concat(get(_patientsData, ["data", "first_id"])));
        trackEvent(MIXPANEL_EVENTS.VIEWER_HEADER_NAVIGATION, {
          type: type
        });
      })["catch"](function (e) {
        console.error("err", e);
      });
    }
  };
  var onBack = function onBack() {
    if (isIOSWebView()) {
      router.back();
    } else {
      router.replace("/patients/".concat(patient_uid));
    }
    trackEvent(MIXPANEL_EVENTS.EXIT_VIEWER);
    Store.update(function (s) {
      s.swiftModeEnabled = false;
    });
    localStorage.removeItem(constants.PERSISTED.isSwiftReportModeEnabled);
    if (swiftModeEnabled) {
      setFilters(constants.DEEFAULT_FILTER);
    }
  };
  useMenubarActions(onBack);
  useEffect(function () {
    if (userInfo !== null && userInfo !== void 0 && userInfo.patients_export) {
      Store.update(function (s) {
        var _userInfo$patients_ex, _userInfo$patients_ex2, _userInfo$patients_ex3, _userInfo$patients_ex4;
        s.isExportReady = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex = userInfo.patients_export) === null || _userInfo$patients_ex === void 0 ? void 0 : _userInfo$patients_ex.available;
        s.exportTimestamp = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex2 = userInfo.patients_export) === null || _userInfo$patients_ex2 === void 0 ? void 0 : _userInfo$patients_ex2.timestamp;
        s.downloadProgress = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex3 = userInfo.patients_export) === null || _userInfo$patients_ex3 === void 0 ? void 0 : _userInfo$patients_ex3.progress;
        s.exportGenFailed = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex4 = userInfo.patients_export) === null || _userInfo$patients_ex4 === void 0 ? void 0 : _userInfo$patients_ex4.failed;
      });
    }
  }, [userInfo]);
  var AddPhoneNumber = function AddPhoneNumber() {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames({
        hidden: isOnpremise || !ALLOWED_REGIONS_FOR_PHONE_AUTH.some(function (region) {
          var _window;
          return (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host.includes(region);
        })
      }),
      onClick: function onClick() {
        Store.update(function (s) {
          s.addPhoneModal = true;
        });
        var event = MIXPANEL_EVENTS.OPEN_ADD_PHONE_NUMBER;
        if (!isEmpty(phoneNumber)) {
          event = MIXPANEL_EVENTS.OPEN_UPDATE_PHONE_NUMBER;
        }
        trackEvent(event);
      }
    }, !isEmpty(phoneNumber) ? /*#__PURE__*/React.createElement("div", {
      className: "!cursor-pointer text-md text-gray-400 break-all"
    }, phoneNumber, " ", /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPencil,
      size: "lg",
      className: "w-4 ml-2 text-teal-400"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "text-md text-teal-400 !cursor-pointer hover:underline"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPlus,
      className: "hidden w-4 mr-2 text-teal-400"
    }), "".concat(t("add_phone.link"), " ").concat(t("phone_number"))));
  };
  useEffect(function () {
    var _showDiskAlert = diskUsage && [75, 80, 85].includes(diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent);
    if (_showDiskAlert) {
      if (DiskAlertbuttonRef.current) {
        var _DiskAlertbuttonRef$c;
        DiskAlertbuttonRef === null || DiskAlertbuttonRef === void 0 || (_DiskAlertbuttonRef$c = DiskAlertbuttonRef.current) === null || _DiskAlertbuttonRef$c === void 0 || _DiskAlertbuttonRef$c.click();
      }
    }
    if ((diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 90) {
      Store.update(function (s) {
        s.isDiskSpaceWarning = true;
      });
    }
  }, [diskUsage]);
  var triggerButtonClick = function triggerButtonClick() {
    if (LicenseAlertbuttonRef !== null && LicenseAlertbuttonRef !== void 0 && LicenseAlertbuttonRef.current) {
      LicenseAlertbuttonRef.current.click();
    }
  };
  useEffect(function () {
    if (alertDetails !== null && alertDetails !== void 0 && alertDetails.isPopupVisible) {
      setTimeout(function () {
        triggerButtonClick();
      }, 800);
    }
  }, [alertDetails]);
  useEffect(function () {
    var _wsData$content;
    if ((wsData === null || wsData === void 0 ? void 0 : wsData.action) === "license_activation" && wsData !== null && wsData !== void 0 && (_wsData$content = wsData.content) !== null && _wsData$content !== void 0 && _wsData$content.license_activated) {
      triggerButtonClick();
    }
  }, [wsData]);
  var onDismissLicenseALert = function onDismissLicenseALert() {
    if (!isEmpty(alertDetails)) {
      var app_name = alertDetails.app_name,
        license_type = alertDetails.license_type,
        total_scans_remaining = alertDetails.total_scans_remaining,
        total_scans = alertDetails.total_scans,
        total_days_remaining = alertDetails.total_days_remaining,
        total_days = alertDetails.total_days,
        remainingPercentage = alertDetails.remainingPercentage;
      var _params2 = {
        app_name: app_name,
        license_type: license_type,
        remainingPercentage: remainingPercentage
      };
      if (license_type === "TIME") {
        _params2 = _objectSpread(_objectSpread({}, _params2), {}, {
          total_days_remaining: total_days_remaining,
          total_days: total_days
        });
      } else if (license_type === "CONT") {
        _params2 = _objectSpread(_objectSpread({}, _params2), {}, {
          total_scans_remaining: total_scans_remaining,
          total_scans: total_scans
        });
      }
      localStorage.setItem("licenseAlertDismissed", JSON.stringify(_params2));
    }
  };
  var diskAlertPrompt = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTriangleExclamation,
      size: "xl",
      className: "text-yellow-500"
    }), " ", t("disk_management.x_storage_full", {
      usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent
    })), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, t("disk_management.alert", {
      usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent,
      totalDisk: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.total
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grow-1 px-4 py-3 text-gray-500",
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_DISMISSED);
      }
    }, t("Dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "disk-management";
        });
        setOpen(true);
        trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_MANAGE_STORAGE_CLICKED);
      },
      className: "grow-1 px-4 py-3 text-teal-500"
    }, t("disk_management.manage_storage"), " ", ">"))),
    onClick: function onClick() {}
  }];
  var licenseAlertPrompt = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: classNames("flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700", {
        hidden: !get(alertDetails, ["isAlert"], false)
      })
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTriangleExclamation,
      size: "xl",
      className: "text-yellow-500"
    }), " ", (alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.license_type) === "TIME" ? "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_days_remaining, " days") : "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_scans_remaining, " scans"), " ", "left"), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, (alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.license_type) === "TIME" ? t("license_manager.license_expire_in_alert").replace("[1]", "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_days_remaining)) : t("license_manager.license_expire_after_alert").replace("[1]", "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_scans_remaining))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grow-1 px-4 py-3 text-gray-500",
      onClick: function onClick() {
        onDismissLicenseALert();
        trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_DISMISSED);
      }
    }, t("Dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "license";
        });
        setOpen(true);
        trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_VIEW_DETAILS_CLICKED);
      },
      className: "grow-1 px-4 py-3 text-teal-500"
    }, t("view_details"), " ", ">"))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: classNames("flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700", {
        hidden: get(alertDetails, ["isAlert"], false)
      })
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faBadgeCheck,
      size: "xl",
      className: "text-green-500"
    }), " ", t("license_manager.license_activated")), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, t("license_manager.your_license_activated")), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grow-1 px-4 py-3 text-gray-500"
    }, t("Dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "license";
        });
        setOpen(true);
        trackEvent(MIXPANEL_EVENTS.LICENSE_ACTIVATED_VIEW_DETAILS);
      },
      className: "grow-1 px-4 py-3 text-teal-500"
    }, t("view_details"), " ", ">"))),
    onClick: function onClick() {}
  }];
  var profileNavigations = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start p-4 bg-gray-700 overflow-hidden rounded-t text-white"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserIcon, {
      name: get(user, ["name"], "") || get(user, ["preferred_username"], ""),
      className: "h-8 w-8 text-lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pl-4 flex flex-col items-start justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-medium text-base break-all"
    }, get(user, ["name"], "") || get(user, ["preferred_username"], "")), /*#__PURE__*/React.createElement("div", {
      className: "text-md text-gray-400 break-all"
    }, get(user, ["email"], "")), /*#__PURE__*/React.createElement(AddPhoneNumber, null))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faInfoCircle
    }), /*#__PURE__*/React.createElement("p", null, t("settings.terms-of-use"))),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_TERMS_OF_USE);
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faLocationDot
    }), /*#__PURE__*/React.createElement("p", null, t(getCurrentRegion()))),
    className: "!text-gray-800 dark:!text-gray-200 !cursor-default !bg-transparent",
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowRightFromBracket,
      size: "lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, t("logout_key"))),
    onClick: function onClick() {
      Store.update(function (s) {
        s.isLogoutOpen = true;
      });
      trackEvent(MIXPANEL_EVENTS.LOGOUT_MODAL_OPENED);
    }
  }];
  var toggleProductButton = function toggleProductButton() {
    setEnableTour(true);
    trackEvent(MIXPANEL_EVENTS.PRODUCT_TOUR_OPENED);
  };
  var onToggleThemeClick = function onToggleThemeClick() {
    if (window) {
      localStorage.setItem(constants.PERSISTED.isDarkMode, String(!isDarkMode));
      Store.update(function (s) {
        s.isDarkMode = !isDarkMode;
      });
      trackEvent(MIXPANEL_EVENTS.THEME_CHANGED, {
        isDarkMode: !isDarkMode
      });
    }
  };

  // Add keyboard shortcut handler
  useEffect(function () {
    var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
    if (!isAIAssistantEnabled) return;
    var handleKeyDown = function handleKeyDown(e) {
      // Check for CMD+/ (Mac) or CTRL+/ (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === "/") {
        e.preventDefault(); // Prevent default browser behavior
        Store.update(function (s) {
          s.isDraggableModalOpen = !s.isDraggableModalOpen;
        });
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return function () {
      return window.removeEventListener("keydown", handleKeyDown);
    };
  }, [userInfo]);
  if (!onlyViewport && urlAuthToken && !isLoggedIn) {
    var onClose = function onClose() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = false;
      });
    };
    var onOpen = function onOpen() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = true;
      });
    };
    return /*#__PURE__*/React.createElement("header", {
      className: classNames("flex items-center bg-gray-900 px-5 py-4 border-b border-gray-800", {
        "pt-8": isWebView()
      })
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      onClick: function onClick() {
        return trackEvent(MIXPANEL_EVENTS.LOGO_CLICKED, {
          label: "guest_header"
        });
      }
    }, /*#__PURE__*/React.createElement(Image, {
      className: "block h-auto w-auto cursor-pointer",
      src: logo,
      alt: "Qure.ai",
      width: "76",
      height: "25"
    })), /*#__PURE__*/React.createElement("button", {
      className: "bg-teal-500 ml-auto py-3 px-5 rounded-lg",
      onClick: function onClick() {
        onOpen();
        trackEvent(MIXPANEL_EVENTS.GET_FULL_ACCESS_CLICKED);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-gray-200"
    }, t("full_access"))), /*#__PURE__*/React.createElement(Modal, {
      show: isGetFullAccessOpen,
      onClose: onClose,
      title: "Get Full Access",
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
      closeOnClickAway: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-lg text-gray-800 dark:text-gray-200 py-3"
    }, t("add_worklist_signin_access")), /*#__PURE__*/React.createElement("div", {
      className: "text-gray-100 text-base space-x-5"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        onClose();
        trackEvent(MIXPANEL_EVENTS.GET_FULL_ACCESS_DISMISSED);
      },
      className: "grow-1 px-6 py-4"
    }, t("no_thanks")), /*#__PURE__*/React.createElement(Button, {
      isPrimary: true,
      onClick: function onClick() {
        router.replace("/account/login", undefined, {
          shallow: true
        });
        trackEvent(MIXPANEL_EVENTS.GET_FULL_ACCESS_SIGN_IN);
      },
      className: "grow-1 px-6 py-4"
    }, t("add_worklist"))))));
  }
  var tabsOptions = [{
    id: t("worklist_key"),
    label: t("worklist_key"),
    value: "/patients"
  }, {
    id: t("dashboard_key"),
    label: t("dashboard_key"),
    value: "/dashboard"
  }, {
    id: t("Admin"),
    label: t("Admin"),
    value: "/admin"
  }];
  var selectedTab = isBulkActions ? tabsOptions[0] // Worklist tab
  : tabsOptions.find(function (opt) {
    return opt.value === window.location.pathname;
  }) || tabsOptions[0];
  var disableAddPatient = isOnpremise && (diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 99;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Transition.Root, {
    show: open,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "relative lg:hidden",
    onClose: setOpen
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition-opacity ease-linear duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-linear duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-25"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex text-gray-200"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "-translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "-translate-x-full"
  }, /*#__PURE__*/React.createElement(Dialog.Panel, {
    className: "relative flex flex-col w-full overflow-y-auto bg-gray-800 shadow-xl"
  }, /*#__PURE__*/React.createElement(SettingsMenu, {
    onLogout: function onLogout() {
      Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  })))))), /*#__PURE__*/React.createElement("header", {
    className: classNames("bg-gray-900 shadow-sm lg:static lg:overflow-y-visible h-fit border-b-none sm:border-b border-gray-800", {
      "hidden sm:block": hideMenubar,
      "pt-7": isWebView(),
      "!bg-gray-800 sm:!bg-gray-900": isWorkList
    }),
    id: "menubar"
  }, !hasMobileSearch && /*#__PURE__*/React.createElement("div", {
    className: "mx-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("relative flex sm:justify-between sm:w-full", {
      "w-full": isWorkList || isDashboard
    })
  }, !(isNotificationSettings || isGatewayIndicator || isPatientRegistration || isFormSettings) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sm:hidden inset-y-0"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setOpen(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_SETTINGS);
    },
    className: "-mx-2 rounded-md p-5 inline-flex items-center justify-center text-gray-200"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("open_menu")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAlignJustify,
    size: "lg",
    className: "w-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:left-0 md:inset-y-0 lg:static xl:col-span-2 w-full sm:w-auto justify-center items-center sm:items-stretch"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:flex justify-center items-center ml-4 cursor-pointer shrink-0",
    onClick: function onClick() {
      return trackEvent(MIXPANEL_EVENTS.LOGO_CLICKED, {
        label: "main_header"
      });
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block h-auto w-auto",
    src: logo,
    alt: "Qure.ai",
    width: "76",
    height: "25"
  }))), (isDashboard || isWorkList || isAdminView || isBulkActions) && metabase_enabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 flex items-center whitespace-nowrap ".concat(router.asPath === "/dashboard" ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10 ", "\n                                 transition duration-500\n                                 hover:bg-teal-500/10 ml-6 px-4"),
    onClick: function onClick() {
      return trackEvent(MIXPANEL_EVENTS.NAV_TAB_CLICKED, {
        tab: "dashboard"
      });
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/dashboard"
  }, t("dashboard_key"))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 text-nowrap flex items-center ".concat(/patients/g.test(router.asPath) || isBulkActions ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10", "\n                               transition duration-500 hover:bg-teal-500/10 px-4"),
    onClick: function onClick() {
      return trackEvent(MIXPANEL_EVENTS.NAV_TAB_CLICKED, {
        tab: "worklist"
      });
    }
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/patients"
  }, t("worklist_key")))), /*#__PURE__*/React.createElement(Dropdown, {
    options: tabsOptions,
    isBottomAligned: true,
    onChange: function onChange(opt) {
      router.push(opt.value, undefined, {
        shallow: true
      });
      trackEvent(MIXPANEL_EVENTS.NAV_TAB_CLICKED, {
        tab: opt.id
      });
    },
    selectedOption: selectedTab,
    hasArrow: true,
    className: classNames("flex sm:hidden font-medium w-full", {
      hidden: getIsRemoteSystem()
    }),
    iconClassName: "text-md text-teal-300",
    parentClassName: "z-50"
  })), /*#__PURE__*/React.createElement(AdminViewBtn, {
    metabase_enabled: metabase_enabled
  }), isWorkList && !metabase_enabled && /*#__PURE__*/React.createElement("p", {
    className: "text-gray-100 flex items-center sm:hidden"
  }, t("worklist_key")), isViewerPage && /*#__PURE__*/React.createElement("span", {
    onClick: onBack,
    className: classNames("flex justify-center items-center text-gray-200 cursor-pointer p-5", {
      "ml-8 border-l border-gray-800": !isWorkList && !isNotificationSettings && !isGatewayIndicator && !isFormSettings && !isPatientRegistration
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAngleLeft,
    className: "ml-3 w-5 mr-3"
  }), t("back_key")))), /*#__PURE__*/React.createElement("div", {
    className: classNames("hidden items-center text-white md:space-x-8", {
      "!flex": isViewer
    })
  }, /*#__PURE__*/React.createElement(Tooltip, {
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("previous_patient"))),
    position: "right",
    verticalPosition: "bottom",
    className: classNames("[&_.tooltip-content]:text-sm [&_.tooltip-content]:rounded-6 [&_.tooltip-content]:p-3 [&_.tooltip-content]:px-4 [&_.tooltip-content]:text-gray-100", {
      hidden: isNewViewer
    }),
    disabled: (indexOfCurrentPatient === 0 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === 0 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    onClick: function onClick() {
      handleChangeButton("prev");
    },
    className: "disabled:opacity-50 cursor-pointer disabled:cursor-default hidden md:items-center disabled:hover:bg-transparent md:hover:bg-gray-700 md:rounded-6 md:flex md:w-7 md:h-7 md:justify-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "items-center text-gray-200 flex"
  }, hasPatientDetails && !isWorkList && !isDashboard && !isNotificationSettings && !isGatewayIndicator && !isFormSettings && !isPatientRegistration && /*#__PURE__*/React.createElement("span", {
    className: "break-all"
  }, (_activePatientDetail$ = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.name) !== null && _activePatientDetail$ !== void 0 ? _activePatientDetail$ : patientBio === null || patientBio === void 0 ? void 0 : patientBio.name, " |", " ", /*#__PURE__*/React.createElement("span", {
    title: (_activePatientDetail$2 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$2 !== void 0 ? _activePatientDetail$2 : patientBio === null || patientBio === void 0 ? void 0 : patientBio.patientID
  }, (_ref = (_activePatientDetail$3 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$3 !== void 0 ? _activePatientDetail$3 : patientBio === null || patientBio === void 0 ? void 0 : patientBio.patientID) === null || _ref === void 0 ? void 0 : _ref.slice(0, 10)))), /*#__PURE__*/React.createElement(Tooltip, {
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("next_patient"))),
    position: "left",
    verticalPosition: "bottom",
    className: classNames("[&_.tooltip-content]:text-sm [&_.tooltip-content]:rounded-6 [&_.tooltip-content]:p-3 [&_.tooltip-content]:px-4 [&_.tooltip-content]:text-gray-100", {
      hidden: isNewViewer
    }),
    disabled: (indexOfCurrentPatient === _patientsUID.length - 1 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === _patientsUID.length - 1 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    className: "disabled:opacity-50 cursor-pointer disabled:cursor-default hidden md:items-center disabled:hover:bg-transparent md:hover:bg-gray-700 md:rounded-6 md:flex md:w-7 md:h-7 md:justify-center",
    onClick: function onClick() {
      handleChangeButton("next");
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronRight,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  })))), swiftModeEnabled && isViewerPage && /*#__PURE__*/React.createElement("div", {
    className: "border-teal-700 group z-50 relative h-fit my-auto flex items-center border rounded-lg bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-teal-800 py-3 pr-5 pl-2 border-teal-700 border-r rounded-l-lg flex items-center space-x-4"
  }, /*#__PURE__*/React.createElement("svg", {
    onClick: function onClick() {
      setShowSwiftFilter(!showSwiftFilter);
      trackEvent(MIXPANEL_EVENTS.SWIFT_FILTER_TOGGLED, {
        visible: !showSwiftFilter
      });
    },
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 cursor-pointer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 4.5C15.0273 4.5 15.75 5.22109 15.75 6.10937C15.75 6.51562 15.5977 6.91016 15.2852 7.20703L11.6523 11.1172V18.2266C11.6523 18.9297 11.1172 19.5 10.4141 19.5C10.1289 19.5 9.91797 19.4258 9.71094 19.2891L6.73047 17.3438C6.32422 17.0547 6.0625 16.5625 6.0625 16.0391V11.1172L2.43047 7.20703C2.15375 6.91016 2 6.51562 2 6.10937C2 5.22109 2.72109 4.5 3.61055 4.5H14.1406ZM7.90234 10.75V15.8711L9.77734 17.1094V10.75C9.77734 10.5117 9.90234 10.2852 10.0625 10.1133L13.5312 6.375H4.2168L7.6875 10.1133C7.84766 10.2852 7.90234 10.5117 7.90234 10.75ZM21.0625 17.3125C21.582 17.3125 22 17.7305 22 18.25C22 18.7695 21.582 19.1875 21.0625 19.1875H15.4375C14.918 19.1875 14.5 18.7695 14.5 18.25C14.5 17.7305 14.918 17.3125 15.4375 17.3125H21.0625ZM14.5 12C14.5 11.4805 14.918 11.0625 15.4375 11.0625H21.0625C21.582 11.0625 22 11.4805 22 12C22 12.5195 21.582 12.9375 21.0625 12.9375H15.4375C14.918 12.9375 14.5 12.5195 14.5 12ZM21.0625 4.8125C21.582 4.8125 22 5.23242 22 5.75C22 6.26953 21.582 6.6875 21.0625 6.6875H17.9375C17.418 6.6875 17 6.26953 17 5.75C17 5.23242 17.418 4.8125 17.9375 4.8125H21.0625Z",
    className: "fill-gray-500 dark:fill-gray-400"
  })), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-teal-300 "
  }, indexOfCurrentPatient + 1, " of ", count)), /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium px-5 py-3"
  }, t("swift_report_mode")), /*#__PURE__*/React.createElement("button", {
    title: t("exit_swift_reporting_mode"),
    onClick: function onClick() {
      onBack();
    },
    className: "bg-red-700 invisible group-hover:visible border border-gray-600 rounded-r-lg px-3 py-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "w-6 h-6 text-gray-100 stroke-2"
  })), showSwiftFilter && /*#__PURE__*/React.createElement("div", {
    className: "absolute translate-y-[75%] z-50 bg-gray-800 border text-gray-200 gap-4 rounded-xl border-gray-700 flex flex-wrap p-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("negative")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("screened_by_qure")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, "CXR"))), /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex sm:gap-2 sm:items-center sm:justify-end xl:col-span-4"
  }, !isEmpty(userWorkspaces) && isWorkList && !isLC && /*#__PURE__*/React.createElement("div", {
    className: "z-20 p-3"
  }, /*#__PURE__*/React.createElement(SelectWorkspace, {
    siteOptions: (userWorkspaces === null || userWorkspaces === void 0 || (_userWorkspaces$filte = userWorkspaces.filter(function (src) {
      return !src.data_hidden;
    })) === null || _userWorkspaces$filte === void 0 ? void 0 : _userWorkspaces$filte.map(function (src) {
      return {
        label: src.name,
        value: src.id,
        id: src.uuid,
        role: src.role,
        has_permission: src.has_permission,
        synced: src.synced
      };
    })) || [],
    className: "w-full !z-10",
    setSelectedSource: setSelectedWorkspace,
    selectedSource: selectedWorkspace
  })), get(userInfo, ["settings", "ui_settings", "ai_assistant"], false) && !get(router, ["route"], "").includes("/patients/") && !get(router, ["route"], "").includes("/viewer/") && !get(router, ["route"], "").includes("/worklist") && !get(router, ["route"], "").includes("/admin") && /*#__PURE__*/React.createElement("button", {
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 " + "text-gray-100 !px-4 !py-2 mr-6 border border-brand-peach hover:opacity-80 cursor-pointer user-select-none"),
    "data-testid": "assistant-button",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_OPEN);
      Store.update(function (s) {
        s.isDraggableModalOpen = !s.isDraggableModalOpen;
      });
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/icons/aira-logo.svg",
    alt: "aira-logo",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:inline ml-3 font-bold font-sans"
  }, "AIRA")), !isAdminView && !isViewer && /*#__PURE__*/React.createElement(DropdownMenu, {
    hasCustomControl: true,
    menuItemClassName: "!w-40",
    options: [{
      name: /*#__PURE__*/React.createElement("button", {
        className: "flex gap-5 justify-center items-center h-[40px] pl-3",
        "data-testid": "add-patient-button",
        onClick: function onClick() {
          Store.update(function (s) {
            s.uploadModal = {
              isOpen: true,
              hasCurrentPatient: false
            };
          });
          trackEvent(MIXPANEL_EVENTS.OPEN_ADD_PATIENT);
        }
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleUser,
        className: "text-lg mr-[-2px]"
      }), /*#__PURE__*/React.createElement("span", null, t("add_key"), " Patient"))
    }, {
      name: /*#__PURE__*/React.createElement("button", {
        className: "flex gap-5 justify-center items-center h-[40px] pl-3",
        "data-testid": "import-csv-button",
        onClick: function onClick() {
          Store.update(function (s) {
            s.showCsvUploadModal = true;
          });
          trackEvent(MIXPANEL_EVENTS.UPLOAD_CSV);
        }
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faFileArrowUp,
        className: "text-lg pl-1"
      }), /*#__PURE__*/React.createElement("span", null, "Import CSV"))
    }],
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("button", {
        className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 !px-5 !py-3 mr-3 bg-teal-800 gap-4")
      }, t("add_key"), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faChevronDown,
        className: "text-md"
      }));
    },
    onOpen: function onOpen() {
      return trackEvent(MIXPANEL_EVENTS.ADD_DROPDOWN_OPENED);
    }
  }), get(userInfo, ["settings", "ui_settings", "support_widget_enabled"], false) && !isAdminView && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 !px-5 !py-3 mr-3 gap-4", isSupportWidgetOpen ? "bg-teal-600 hover:bg-teal-700 ring-2 ring-teal-400/50" : "bg-teal-800 hover:bg-teal-900"),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isSupportWidgetOpen = !s.isSupportWidgetOpen;
      });
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMessagesQuestion,
    className: "text-lg"
  })), totalGateway > 0 && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: [{
      name: /*#__PURE__*/React.createElement("div", {
        className: "flex p-4 items-center justify-start hover:!bg-teal-500 dark:hover:!bg-teal-800 border-t border-gray-300 dark:border-gray-500/40"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleInfo,
        size: "lg",
        className: "w-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start ml-3"
      }, t("more_information"))),
      onClick: function onClick() {
        openSetting(constants.SETTINGS.GATEWAY);
        trackEvent(MIXPANEL_EVENTS.GATEWAY_MORE_INFO_CLICKED);
      }
    }],
    menuItemClassName: "z-50 w-80",
    childrenContent: /*#__PURE__*/React.createElement(GatewayDropdown, null),
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative",
        onClick: function onClick() {
          return trackEvent(MIXPANEL_EVENTS.GATEWAY_INDICATOR_CLICKED);
        }
      }, offlineGatewayCount > 0 && /*#__PURE__*/React.createElement("div", {
        className: "absolute border-2 text-gray-100 border-gray-900 flex justify-center items-center text-sm rounded-full bg-red-500 right-4 font-medium top-3 w-5 h-5"
      }, offlineGatewayCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faArrowUpArrowDown,
        size: "lg",
        className: "m-5 text-gray-200"
      }));
    }
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    refer: LicenseAlertbuttonRef,
    options: licenseAlertPrompt,
    menuItemClassName: "z-50 w-80",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, alertDetails !== null && alertDetails !== void 0 && alertDetails.isAlert ? /*#__PURE__*/React.createElement("div", {
        className: "relative",
        onClick: function onClick(e) {
          trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_CLICKED);
          if (!alertDetails.remainingPercentage) {
            e.stopPropagation();
            Store.update(function (s) {
              s.isSettingsOpen = true;
              s.selectedSetting = "license";
            });
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "absolute -right-3 -top-3"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faTriangleExclamation,
        size: "sm",
        className: "m-5 text-yellow-500"
      })), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faKey,
        size: "lg",
        className: "m-5 text-gray-200"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "h-8"
      }));
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: classNames("flex group text-gray-200 border-b-2 relative z-10 border-transparent hover:text-gray-100 hover:bg-teal-900", {
      "bg-teal-900 !text-gray-100 !border-teal-500": isSettingsOpen
    }),
    "data-testid": "settings-button",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isSettingsOpen = true;
      });
      trackEvent(MIXPANEL_EVENTS.OPEN_SETTINGS);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    label: "settings",
    name: faGear,
    size: "lg",
    className: "m-5"
  })), isOnpremise && isPatientDeletionEnabled && (diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 75 && /*#__PURE__*/React.createElement(DropdownMenu, {
    refer: DiskAlertbuttonRef,
    options: diskAlertPrompt,
    menuItemClassName: "z-50",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "56",
        height: "64",
        viewBox: "0 0 56 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M19 23.75C18.5875 23.75 18.25 24.0875 18.25 24.5V32.0938C18.4891 32.0328 18.7422 32 19 32H37C37.2578 32 37.5109 32.0328 37.75 32.0938V24.5C37.75 24.0875 37.4125 23.75 37 23.75H19ZM18.25 35V39.5C18.25 39.9125 18.5875 40.25 19 40.25H37C37.4125 40.25 37.75 39.9125 37.75 39.5V35C37.75 34.5875 37.4125 34.25 37 34.25H19C18.5875 34.25 18.25 34.5875 18.25 35ZM16 35V24.5C16 22.8453 17.3453 21.5 19 21.5H37C38.6547 21.5 40 22.8453 40 24.5V35V39.5C40 41.1547 38.6547 42.5 37 42.5H19C17.3453 42.5 16 41.1547 16 39.5V35ZM29.125 37.25C29.125 36.9516 29.2435 36.6655 29.4545 36.4545C29.6655 36.2435 29.9516 36.125 30.25 36.125C30.5484 36.125 30.8345 36.2435 31.0455 36.4545C31.2565 36.6655 31.375 36.9516 31.375 37.25C31.375 37.5484 31.2565 37.8345 31.0455 38.0455C30.8345 38.2565 30.5484 38.375 30.25 38.375C29.9516 38.375 29.6655 38.2565 29.4545 38.0455C29.2435 37.8345 29.125 37.5484 29.125 37.25ZM34.75 36.125C35.0484 36.125 35.3345 36.2435 35.5455 36.4545C35.7565 36.6655 35.875 36.9516 35.875 37.25C35.875 37.5484 35.7565 37.8345 35.5455 38.0455C35.3345 38.2565 35.0484 38.375 34.75 38.375C34.4516 38.375 34.1655 38.2565 33.9545 38.0455C33.7435 37.8345 33.625 37.5484 33.625 37.25C33.625 36.9516 33.7435 36.6655 33.9545 36.4545C34.1655 36.2435 34.4516 36.125 34.75 36.125Z",
        fill: "#D9DBDD"
      }), /*#__PURE__*/React.createElement("g", {
        clipPath: "url(#clip0_5582_11554)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M41.9995 11.25C42.5542 11.25 43.0659 11.543 43.3472 12.0234L51.7847 26.3984C52.0698 26.8828 52.0698 27.4805 51.7925 27.9648C51.5152 28.4492 50.9956 28.75 50.437 28.75H33.562C33.0034 28.75 32.4839 28.4492 32.2066 27.9648C31.9292 27.4805 31.9331 26.8789 32.2144 26.3984L40.6519 12.0234C40.9331 11.543 41.4448 11.25 41.9995 11.25ZM41.9995 16.25C41.48 16.25 41.062 16.668 41.062 17.1875V21.5625C41.062 22.082 41.48 22.5 41.9995 22.5C42.5191 22.5 42.937 22.082 42.937 21.5625V17.1875C42.937 16.668 42.5191 16.25 41.9995 16.25ZM43.2495 25C43.2495 24.6685 43.1178 24.3505 42.8834 24.1161C42.649 23.8817 42.3311 23.75 41.9995 23.75C41.668 23.75 41.3501 23.8817 41.1157 24.1161C40.8812 24.3505 40.7495 24.6685 40.7495 25C40.7495 25.3315 40.8812 25.6495 41.1157 25.8839C41.3501 26.1183 41.668 26.25 41.9995 26.25C42.3311 26.25 42.649 26.1183 42.8834 25.8839C43.1178 25.6495 43.2495 25.3315 43.2495 25Z",
        fill: "#FFA000"
      })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
        id: "clip0_5582_11554"
      }, /*#__PURE__*/React.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(32 10)"
      }))));
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: toggleProductButton,
    className: classNames("hover:bg-teal-900 h-full px-5 border-b-2 border-gray-900", {
      hidden: !getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID")
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faQuestionCircle,
    className: "text-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex items-center h-full px-3 border-b-2 border-gray-900"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onToggleThemeClick,
    title: isDarkMode ? t("settings.light") : t("settings.dark"),
    className: "flex items-center bg-gray-700 rounded-full p-0.5 gap-0.5 hover:bg-gray-600 transition-colors"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("p-1.5 rounded-full transition-all duration-200", {
      "bg-gray-900 text-blue-300": isDarkMode,
      "text-gray-500": !isDarkMode
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMoon,
    className: "w-3 h-3 block"
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames("p-1.5 rounded-full transition-all duration-200", {
      "bg-amber-400 text-gray-900": !isDarkMode,
      "text-gray-500": isDarkMode
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSunBright,
    className: "w-3 h-3 block"
  })))), isLoggedIn && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: profileNavigations,
    menuItemClassName: "z-50",
    Icon: function Icon(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return !open && trackEvent(MIXPANEL_EVENTS.PROFILE_DROPDOWN_OPENED);
        }
      }, /*#__PURE__*/React.createElement(UserIcon, {
        className: classNames("h-7 w-7 m-4 group-hover:bg-gray-700", {
          "!bg-gray-700": open
        }),
        name: get(user, ["name"], "") || get(user, ["preferred_username"], "")
      }));
    },
    dataTestId: "user-profile-dropdown"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-5 sm:hidden flex justify-end items-center"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.hasMobileSearch = true;
      });
      trackEvent(MIXPANEL_EVENTS.MOBILE_SEARCH_OPENED);
    },
    className: classNames("relative text-white", {
      hidden: !isWorkList
    })
  }, (filters === null || filters === void 0 ? void 0 : filters.isFilterApplied) && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircle,
    size: "2xs",
    className: "absolute top-0 right-1 text-teal-400 p-1 bg-gray-800 rounded-full"
  }), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSearch,
    className: "w-6"
  }))))), showTermsAndConditionsModal && /*#__PURE__*/React.createElement(TermsAndConditionsModal, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    },
    showModal: showTermsAndConditionsModal
    // closeOnClickAway
    ,
    mode: "readonly"
  })));
};
export default Menubar;